import * as React from 'react';

const MinusSprite = (props) => (
    <svg
        {...props}
        fill='none'
        height={16}
        viewBox='0 0 36 16'
        width={36}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M19.5 7.375v1.25h12v-1.25zM2 7.375v1.25h12v-1.25z'
            fill='currentColor' />
    </svg>
);

export default MinusSprite;
